////////LIBRARY/////////
import { cloneDeep, filter, find, isEmpty, isNull, isUndefined, map, isEqual } from 'lodash'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
///////COMPONENTS///////
import DropdownCheckbox from '../../components/DropdownCheckbox'
import Modals from '../../components/Modals'
import Tooltip from '../../components/Tooltip/Tooltip'
import Button from '../../components/Ui/Buttons'
import { usagePicsConfig, articleStatusPicsConfig } from '../../constants/AssetsPicturesConfigList'
import ToggleFilters from '../../components/Ui/ToggleFilters'
import { uriList } from '../../routings/settings/RouteList'
import { articleManagerActionCreators } from '../../store/actions'
import {
	ButtonWrapper,
	ControllerFileWrapper,
	ErrorInputMsg,
	InputLogin,
	InputWrapper,
	LabelFileCustom,
	LabelText,
	OptionCustom,
	PageTitle,
	PageWrapperActionReset,
	PageWrapperActions,
	PageWrapperActionTrash,
	PageWrapperActionValidate,
	PageWrapperGrids,
	PageWrapperLinks,
	SearchReset,
	SelectInputCustom,
	SelectInputWrapper,
	TextareaStyled,
	TextModal,
} from '../../theme/GlobalCss'
import theme from '../../theme/theme'
/////////ASSETS/////////
import ArrowDownGrey from '../../assets/icones/global/arrow-down-big-grey.svg'
import ArrowDown from '../../assets/icones/global/arrow-down-big.svg'
import ArrowUpGrey from '../../assets/icones/global/arrow-up-big-grey.svg'
import ArrowUp from '../../assets/icones/global/arrow-up-big.svg'
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'
import noImage from '../../assets/icones/global/no-picture.svg'

/////////STYLED/////////
const ArticleManagerWrapper = styled.div`
	position: relative;
`
const LineTableHeader = styled.div`
	display: grid;
	grid-template-columns: max-content repeat(auto-fit, max-content);
	grid-auto-flow: column;
	grid-column-gap: 16px;
	grid-template-rows: max-content;
	grid-auto-rows: 32px;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	box-sizing: border-box;
`
const ArticleManagerPart = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: repeat(7, max-content);
	grid-row-gap: 20px;
	border-radius: 4px;
	padding: 10px;
	border-right: 1px solid #e5e5e5;
	:first-child {
		padding-left: 0px;
	}
	:last-child {
		padding-right: 0px;
		border-right: none;
	}
`
const ArticleManagerSubPart = styled.div`
	display: flex;
	justify-content: space-between;
	& > *:first-child {
		min-width: 120px;
		margin-right: 10px;
	}
	& > *:last-child {
		margin-left: auto;
	}
	align-items: ${(props) => (props.class === 'va-top' ? 'start' : 'center')};
`
const ArticleManagerState = styled.span`
	color: ${(props) => props.theme.colors.eraser};
	margin-left: 11px;
	line-height: 25px;
	width: ${(props) => (props.width ? '208px' : null)};
`
const PreviewFileWrapper = styled.div`
	margin-left: auto;
	& > img {
		max-width: 375px;
		max-height: 375px;
		border: 1px solid ${(props) => props.theme.colors.TabNav.border};
	}
`
const SearchResetCustom = styled(SearchReset)`
	margin: 0px !important;
`
const ArticleManagerSubPartTextarea = styled(ArticleManagerSubPart)`
	flex-direction: column;
	align-items: start;
	& > div:last-child {
		margin-left: 0px !important;
		width: 100%;
		height: 268px;
	}
`
const ArticleManagerSubPartInputs = styled(ArticleManagerSubPart)`
	flex-direction: column;
	align-items: start;
	& > div:last-child {
		margin-left: 0px !important;
		width: 100%;
	}
	& > div * {
		width: 100%;
	}
`
const ArticleManagerSubPartColumn = styled.div`
	flex-direction: column;
	& > div:last-child {
		margin-left: 0px !important;
	}
	& > div:first-child {
		margin-bottom: 10px;
	}
`
const ArticleManagerSubPartUsagesHandler = styled.div`
    overflow-y: auto;
    height: 200px;
    &::-webkit-scrollbar {
		width: 15px;
		background-color:rgba(0,0,0,.15);
		height: 50px;
	}
	  &::-webkit-scrollbar-thumb {
		  background: #4D4F5C; 
	}
	  &::-webkit-scrollbar-thumb:active {
		background rgba(77, 79, 92, 0.7); 
	}
	  &::-webkit-scrollbar-button:vertical:decrement:single-button {
		  background: no-repeat url(${ArrowUp}) center;
		  height:15px;
	}
  
	  &::-webkit-scrollbar-button:vertical:increment:single-button {
		  background: no-repeat url(${ArrowDown}) center;
		  height:15px;
	}
	&::-webkit-scrollbar-button:vertical:decrement:single-button:active {
		background: no-repeat url(${ArrowUpGrey}) center;
		height:15px;
  }

	&::-webkit-scrollbar-button:vertical:increment:single-button:active {
		background: no-repeat url(${ArrowDownGrey}) center;
		height:15px;
  }
	  /* scrollbar styling standard version */
	  & {
		scrollbar-color: #4D4F5C #E5E5E5;
		scrollbar-width: thin;
	}
`
const ArticleManagerSubPartUsages = styled(ArticleManagerSubPart)`
	display: grid;
	grid-template-columns: auto auto 208px;
	& > div {
		margin-left: 10px !important;
	}
	& > img {
		max-width: 50px;
	}
	& > *:first-child {
		min-width: auto;
	}
	justify-content: left;
	margin-bottom: 10px;
`
const ArticleManagerSubPartAccesory = styled(ArticleManagerSubPart)`
	display: grid;
	grid-template-columns: auto 208px auto;
	& > *:first-child {
		min-width: auto;
	}
	& > img {
		max-width: 50px;
	}
	& > div {
		margin-left: 10px !important;
	}
	justify-content: space-between;
	margin-bottom: 10px;
`
const TextModalWrapper = styled.div`
	width: 102%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 0;
`
const TextModalWrapperBottom = styled(TextModalWrapper)`
	margin-bottom: 15px;
`
const TextModalCustom = styled.div`
	padding: 0;
`
const TextModalPrimary = styled(TextModal)`
	color: ${(props) => props.theme.colors.primary};
	padding: 0;
	margin: 2px 5px;
`
const TextModalRed = styled(TextModal)`
	color: ${(props) => props.theme.colors.error};
`
const StatePicto = styled.img``

const StateWrapper = styled.div`
	display: grid;
	grid-template-columns: 20px 188px;
	align-items: ${(props) => (props.height > 30 ? 'center' : null)};
`
/////////STYLED/////////

const ArticleManager = () => {
	const { translations, articleManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
			articleManager: state.articleManager,
		}),
		shallowEqual
	)

	let history = useHistory()
	const match = useRouteMatch()
	const spanRef = useRef()
	const handleRedirect = () => {
		history.push(`${uriList.distributionItems}${uriList.distributionGroupRepo}`)
	}

	const actionsArticleManager = bindActionCreators(articleManagerActionCreators, useDispatch())

	// Mode of page
	const [isUpdate, setIsUpdate] = useState(false)

	// State of article, will contain an object in update case
	const [stateArticle, setStateArticle] = useState({})
	// State picture
	const [stateArticlePict, setStateArticlePict] = useState({})

	// Type list, based on family selected
	const [typeList, setTypeList] = useState([])
	const [idItemType, setIdItemType] = useState('0')

	// Usage list
	const [usagesList, setUsagesList] = useState([])

	// Features list
	const [featuresList, setFeaturesList] = useState([])
	const [featuresRender, setFeaturesRender] = useState('') // Contains render of features fields
	const [featuresRegistered, setFeaturesRegistered] = useState(false) // Flag to indicate if features fields have been registered

	// Accessories list, based on family selected
	const [accessoriesList, setAccessoriesList] = useState([])

	// When type is chosen, show rest of form
	const [isTypeChosen, setIsTypeChosen] = useState(false)

	const [withDeposit, setWithDeposit] = useState(true)

	const [previewBase64, setPreviewBase64] = useState('')

	const [imgfile, setImgfile] = useState({}) // Will handle image upload attempt by user

	const [dataLoaded, setDataLoaded] = useState(false)

	const [showDeleteModal, setShowDeleteModal] = useState(false)

	const [initialPassedTest, setInitialPassedTest] = useState(false)
	// Default values of the form
	const [stateDefaultValues, setStateDefaultValues] = useState({
		idFamilly: 0,
		idItemType: '0',
		idBrand: 0,
		idItemSpec: 0,
	})

	const { register, handleSubmit, watch, errors, setValue, getValues, control, reset, setError } = useForm({
		defaultValues: stateDefaultValues,
	})

	///////////////////////////////// HANDLE ///////////////////////////////////////

	// When family is selected
	const handleFamilyChoice = (id) => {
		const arr = filter(articleManager.availableOptions.itemFamiliesTypesAccsAvailable, { id: id })
		// Setting type list

		setTypeList(arr[0].itemTypes)
	}

	// When type is selected
	const handleTypeChosen = (val) => {
		const bool = parseInt(val) > 0
		const isBottleType = parseInt(val) === 1 ? false : true
		setWithDeposit(isBottleType)
		setIsTypeChosen(bool)

		if (isBottleType) {
			const arr = filter(articleManager.availableOptions.itemFamiliesTypesAccsAvailable, { id: parseInt(getValues('idFamilly')) })

			setFeaturesList(arr[0].features.sort(sort_features))

			// Setting accessories list
			let acc_list = arr[0].accessories
			map(acc_list, (elem) => {
				elem.label = elem.labelToDisplay
				elem.active = false
			})
			setAccessoriesList(acc_list)
		} else {
			setAccessoriesList([])
		}
		setIdItemType(val)
	}

	// Delete article action
	const handleDelete = () => {
		setShowDeleteModal((prevState) => !prevState)
	}

	// Submitting form
	const onSubmit = (data) => {
		let datas = data
		datas.withDeposit = withDeposit
		// Mapping usages
		datas.idsUsages = map(filter(usagesList, { active: true }), 'id')
		// Replace by . if number with .
		datas.grossWeight = datas.grossWeight.replace(',', '.')
		datas.netWeight = datas.netWeight.replace(',', '.')
		datas.volume = datas.volume.replace(',', '.')
		datas.heightInCm = datas.heightInCm.replace(',', '.')
		// Mapping accessories
		datas.idsAccessories = map(filter(accessoriesList, { active: true }), 'id')
		if (isEmpty(datas.idsAccessories)) delete datas.idsAccessories

		// Revamp pictureBase64
		const pict = cloneDeep(datas.pictureBase64)
		delete datas.pictureBase64
		datas.picture = { pictureBase64: pict }

		if (!isEmpty(articleManager.item)) {
			datas.idFamilly = articleManager.item.idFamilly.toString()
			datas.idItemType = articleManager.item.idItemType.toString()
		}
		if (isUpdate) {
			actionsArticleManager.updateArticle(datas, match.params.id)
		} else {
			actionsArticleManager.createArticle(datas)
		}
	}

	const handleFileReading = (file, _noReplaceName = false) => {
		if (isUndefined(file)) return
		let reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = function () {
			const image = new Image()
			image.src = reader.result

			setValue('pictureBase64', reader.result)
			setPreviewBase64(reader.result)
			//setError('pictureBase64', '')
			setImgfile(file)
		}
		// In case that we need to handle error this way
		// reader.onerror = function (_error) {}
	}

	const handleDeletePicture = () => {
		document.getElementById('pictureBase64').value = ''
		setValue('pictureBase64', '')
		setPreviewBase64('')
	}

	const handleUsagesList = (id, isChecked) => {
		let usages_list = cloneDeep(usagesList)
		usages_list[id]['active'] = !isChecked
		setUsagesList(usages_list)
	}

	const handleAccessoriesList = (id, isChecked) => {
		let acc_list = cloneDeep(accessoriesList)
		if (id === 'checkAll') {
			map(acc_list, (elem) => (elem.active = !isChecked))
		} else {
			map(acc_list, (elem) => {
				if (elem.id === id) elem.active = !isChecked
			})
		}
		setAccessoriesList(acc_list)
	}

	// Resetting form
	const handleResetForm = () => {
		if (!isUpdate) {
			// Resetting form
			if (!isNull(document.getElementById('pictureBase64'))) {
				document.getElementById('pictureBase64').value = ''
				setPreviewBase64('')
			}
			//setPreviewImageName("")
			// And also lists
			let usages_list = cloneDeep(usagesList)
			map(usages_list, (elem) => (elem.active = false))
			setUsagesList(usages_list)

			let acc_list = cloneDeep(accessoriesList)
			map(acc_list, (elem) => (elem.active = false))
			setAccessoriesList(acc_list)
		} else {
			const arr = filter(articleManager.availableOptions.itemFamiliesTypesAccsAvailable, { id: articleManager.item.idFamilly })

			// Setting usages
			let usages_list = cloneDeep(articleManager.availableOptions.usagesAvailable)
			map(usages_list, (elem) => {
				const f = find(articleManager.item.idsUsages, (o) => o === elem.id) ? true : false
				elem.active = f
			})
			setUsagesList(usages_list)

			// Setting accessories
			let acc_list = arr[0].accessories
			map(acc_list, (elem) => {
				elem.label = elem.labelToDisplay
				const f = find(articleManager.item.idsAccessories, (o) => o === elem.id) ? true : false
				elem.active = f
			})
			setAccessoriesList(acc_list)

			const blob = fileFromBase64(articleManager?.item?.picture?.pictureBase64)
			handleFileReading(blob, true)
			//setPreviewImageName("")
		}

		// Back to default states
		reset(stateDefaultValues)
	}

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const cfg_features = [
		{ id: 1, tradLabel: 'dimensions', fieldExpected: 'dimensions', isInput: false },
		{ id: 2, tradLabel: 'Weight', fieldExpected: 'weight', isInput: false },
		{ id: 3, tradLabel: 'empilable', fieldExpected: 'stackable', isInput: true },
		{ id: 4, tradLabel: 'stockWay', fieldExpected: 'storage', isInput: false },
		{ id: 5, tradLabel: 'energyCapacity', fieldExpected: 'energyCapacity', isInput: false },
		{ id: 6, tradLabel: 'plug', fieldExpected: 'junction', isInput: false },
		{ id: 7, tradLabel: 'specificity', fieldExpected: 'specificity', isInput: false },
	]

	const sort_features = (a, b) => {
		let keyA = new Date(a.id),
			keyB = new Date(b.id)
		// Compare the 2 dates
		if (keyA < keyB) return 1
		if (keyA > keyB) return -1
		return 0
	}

	const fileFromBase64 = (data) => {
		if (isUndefined(data)) return
		// Setting image
		let byteString = atob(data.split(',')[1])
		let mimeString = data.split(',')[0].split(':')[1].split(';')[0]

		let ab = new ArrayBuffer(byteString.length)

		let ia = new Uint8Array(ab)
		for (let i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i)
		}
		// write the ArrayBuffer to a blob, and you're done
		let blob = new Blob([ia], { type: mimeString })

		//A Blob() is almost a File() - it's just missing the two properties below which we will add
		blob.lastModifiedDate = new Date()
		blob.name = 'uploadedFile.png'

		return blob
	}

	// Sanitize the eval calls
	const errorsEvalHandler = (_errors, obj1, messageReturn = false) => {
		return messageReturn ? eval(`_errors.${obj1}.message`) : eval(`_errors.${obj1}`)
	}

	const articleManagerEvalHandler = (_articleManager, obj1) => {
		return eval(`_articleManager.item.${obj1}`)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	// On loading page
	useEffect(() => {
		if (isEmpty(translations)) return
		actionsArticleManager.getAvailableLists()
		if (match.url === `${uriList.article}${uriList.articleEdit}/${match.params.id}`) setIsUpdate(true)

		return function cleanUp() {
			actionsArticleManager.resetDataArticle()
		}
	}, [translations])

	// Loading usages list after back call
	useEffect(() => {
		if (!isEmpty(articleManager.availableOptions) && isEmpty(usagesList)) {
			let usages_list = cloneDeep(articleManager.availableOptions.usagesAvailable)
			map(usages_list, (elem) => (elem.active = false))
			setUsagesList(usages_list)
			setDataLoaded(true)
		}
	}, [articleManager.availableOptions])

	useEffect(() => {
		register({ name: 'pictureBase64' } /*,{required: {value:true, message:translations['common__text__requiredField']}}*/)
	}, [register, translations])

	useEffect(() => {
		if (isUpdate) actionsArticleManager.getArticleItem(match.params.id)
	}, [isUpdate])
	useEffect(() => {
		// Setting default values of form
		if (isUpdate && dataLoaded && !isEmpty(articleManager.item)) {
			setValue('itemCode', articleManager.item.itemCode)
			setValue('refName', articleManager.item.refName)
			setValue('shortDescription', articleManager.item.shortDescription)
			setValue('idFamilly', articleManager.item.idFamilly)
			setValue('idBrand', articleManager.item.idBrand)
			setValue('idItemSpec', articleManager.item.idItemSpec)
			setValue('description', articleManager.item.description)
			setValue('netWeight', articleManager.item.netWeight)
			setValue('grossWeight', articleManager.item.grossWeight)
			setValue('volume', articleManager.item.volume)
			setValue('heightInCm', articleManager.item.heightInCm)
			setWithDeposit(articleManager.item.withDeposit)
			setValue('setWithDeposit', articleManager.item.withDeposit)

			const arr = filter(articleManager.availableOptions.itemFamiliesTypesAccsAvailable, { id: articleManager.item.idFamilly })

			setStateArticle(articleManager.item.itemState)

			const pictStateArticle = find(articleStatusPicsConfig, { subFlow: articleManager.item.itemState.subFlow })
			setStateArticlePict(pictStateArticle)

			// Setting type
			setTypeList(arr[0].itemTypes)

			// Setting features
			setFeaturesList(arr[0].features.sort(sort_features))

			// Setting usages
			let usages_list = cloneDeep(articleManager.availableOptions.usagesAvailable)
			map(usages_list, (elem) => {
				const f = find(articleManager.item.idsUsages, (o) => o === elem.id) ? true : false
				elem.active = f
			})
			setUsagesList(usages_list)

			// Setting accessories
			let acc_list = arr[0].accessories
			map(acc_list, (elem) => {
				elem.label = elem.labelToDisplay
				const f = find(articleManager.item.idsAccessories, (o) => o === elem.id) ? true : false
				elem.active = f
			})
			setAccessoriesList(acc_list)

			// Setting picture
			if (!isNull(articleManager.item.picture) && articleManager.item.picture.pictureBase64.length > 0) {
				const blob = fileFromBase64(articleManager?.item?.picture?.pictureBase64)
				handleFileReading(blob, true)
			}

			setStateDefaultValues(getValues())
		}
	}, [articleManager.item, dataLoaded])

	// For setting up the type on update
	useEffect(() => {
		if (typeList.length > 0 && !isEmpty(articleManager.item)) {
			setValue('idItemType', articleManager.item.idItemType)
			setIdItemType(articleManager.item.idItemType)
			setStateDefaultValues(getValues())
		}
	}, [typeList])

	// When featuresList is set, begin rendering and registering
	useEffect(() => {
		if (featuresList.length > 0) {
			setFeaturesRender(
				map(featuresList, (elem, id) => {
					// Getting trad label
					const tradLabel = elem.translationKey.replace('ref__itemFeatures__', '')

					// Matching with field expected for back call
					const fieldResult = find(cfg_features, (o) => {
						return o.tradLabel === tradLabel ? o.fieldExpected : null
					})

					return elem.idItemType === parseInt(idItemType) ? (
						fieldResult.isInput ? (
							<ArticleManagerSubPartInputs>
								<LabelText>{translations[elem.translationKey]} :</LabelText>
								<InputWrapper>
									<InputLogin
										type="text"
										name={fieldResult.fieldExpected}
										placeholder={
											translations[`page__itemsRef__itemSheet_form_itemFeature_${fieldResult.fieldExpected}_prefilled`]
										}
										ref={register({
											maxLength: {
												value: 50,
												message: `50 ${translations['common__text__charMax']}`,
											},
										})}
									/>
									{errorsEvalHandler(errors, fieldResult.fieldExpected) && (
										<ErrorInputMsg>{errorsEvalHandler(errors, fieldResult.fieldExpected, true)}</ErrorInputMsg>
									)}
								</InputWrapper>
							</ArticleManagerSubPartInputs>
						) : (
							<ArticleManagerSubPartInputs>
								<LabelText>{translations[elem.translationKey]} :</LabelText>
								<InputWrapper>
									<TextareaStyled
										name={fieldResult.fieldExpected}
										placeholder={
											translations[`page__itemsRef__itemSheet_form_itemFeature_${fieldResult.fieldExpected}_prefilled`]
										}
										ref={register({
											maxLength: {
												value: 150,
												message: `150 ${translations['common__text__charMax']}`,
											},
										})}
									/>
									{errorsEvalHandler(errors, fieldResult.fieldExpected) && (
										<ErrorInputMsg>{errorsEvalHandler(errors, fieldResult.fieldExpected, true)}</ErrorInputMsg>
									)}
								</InputWrapper>
							</ArticleManagerSubPartInputs>
						)
					) : null
				})
			)
			setFeaturesRegistered(true)
		} else {
			setFeaturesRender('')
			setFeaturesRegistered(false)
		}
	}, [featuresList, idItemType, translations])

	// When features have been rendered AND registered in form,
	// loading item data
	useEffect(() => {
		if (featuresRegistered && isUpdate) {
			const arr = filter(articleManager.availableOptions.itemFamiliesTypesAccsAvailable, { id: articleManager.item.idFamilly })

			map(arr[0].features, (elem) => {
				const tradLabel = elem.translationKey.replace('ref__itemFeatures__', '')

				// Matching with field expected for back call
				const fieldResult = find(cfg_features, (o) => {
					return o.tradLabel === tradLabel ? o.fieldExpected : null
				})

				const val_field = articleManagerEvalHandler(articleManager, fieldResult.fieldExpected)
				setValue(fieldResult.fieldExpected, val_field)
			})
		}
	}, [featuresRender, featuresRegistered])

	// We stock uploaded image by user, only to check shortly after if it is valid
	useEffect(() => {
		if (!isUndefined(match.params.id) && !isUndefined(imgfile) && !initialPassedTest && !isEmpty(translations) && !isUpdate) {
			setInitialPassedTest(true)
		}
		if (
			(!isEqual(imgfile, {}) && !isEmpty(translations) && initialPassedTest && isUpdate) ||
			(!isEqual(imgfile, {}) && !isEmpty(translations) && !isUpdate)
		) {
			const image = new Image()
			const extension = imgfile.name.split('.').pop().toLowerCase()
			const isSuccess = ['png', 'gif', 'jpg', 'jpeg'].indexOf(extension)

			image.src = previewBase64
			if (image.naturalWidth > 375 || image.naturalHeight > 375 || isSuccess < 0 || image.naturalHeight === 0 || image.naturalWidth === 0) {
				document.getElementById('pictureBase64').value = ''
				setPreviewBase64('')
				setValue('pictureBase64', '')
				//setPreviewImageName("")
				setError('pictureBase64', { type: 'custom', message: translations['common__message__item_picture_isNotValid'] })
				setImgfile({})
			} else {
				setError('pictureBase64', { type: 'custom', message: '' })
			}
		}
	}, [imgfile, translations, isUpdate])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<Modals
				title={translations['modal__deleteItem__title']}
				closeModalHandler={handleDelete}
				showModal={showDeleteModal}
				level="error"
				icon={true}
			>
				<TextModalWrapper>
					<TextModalCustom>{translations['modal__deleteItem__description_start']}</TextModalCustom>
					<TextModalPrimary>{`[${articleManager.item.refName}]`}</TextModalPrimary>
					<TextModalCustom>{translations['modal__deleteItem__description_end']}</TextModalCustom>
				</TextModalWrapper>
				<TextModalWrapperBottom>
					<TextModalRed>{translations['modal__deleteItem__warning']}</TextModalRed>
				</TextModalWrapperBottom>
				<ButtonWrapper>
					<Button
						actionHandler={handleDelete}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => {
							actionsArticleManager.deleteArticle(match.params.id)
							handleDelete()
						}}
						text={translations['modal__deleteItem__button_delete']}
						bgColor={theme.colors.validation}
						img={Validation}
						width={300}
					/>
				</ButtonWrapper>
			</Modals>
			<ArticleManagerWrapper>
				<PageWrapperLinks>
					<Button goBack weight="bold" actionHandler={() => handleRedirect()} text={translations['common__text__previousPage']} />
				</PageWrapperLinks>
				<form onSubmit={handleSubmit(onSubmit)}>
					<LineTableHeader>
						<PageTitle>{isUpdate ? translations['page__itemsRef_update_title'] : translations['page__itemsRef_create_title']}</PageTitle>
						<PageWrapperActions>
							<Tooltip translationsKey={'tooltip__admin__global__saveClose'} tooltipId={'articleManagerSubmitArticle'}>
								<PageWrapperActionValidate type="submit" />
							</Tooltip>
							<Tooltip translationsKey={'tooltip__admin__global__reset'} tooltipId={'articleManagerResetArticle'}>
								<PageWrapperActionReset onClick={() => handleResetForm()} />
							</Tooltip>
							<Tooltip
								translationsKey={'tooltip__admin__itemReferential__detail__deleteItem'}
								tooltipId={'articleManagerDeleteArticle'}
							>
								<PageWrapperActionTrash
									disabled={stateArticle?.id !== 2}
									unlocked={stateArticle?.id === 2 && isUpdate}
									onClick={(e) => {
										e.preventDefault()
										return stateArticle.id === 2 && isUpdate ? handleDelete() : null
									}}
								/>
							</Tooltip>
						</PageWrapperActions>
					</LineTableHeader>
					<PageWrapperGrids grids={4}>
						<ArticleManagerPart>
							<ArticleManagerSubPart>
								<LabelText>{translations['page__itemsRef__itemSheet_form_state']} :</LabelText>
								{!isUndefined(articleManager.item.itemState?.picture) ? (
									<StateWrapper height={spanRef?.current?.offsetHeight}>
										{!isEqual(stateArticlePict, {}) && <StatePicto src={stateArticlePict.picture} />}
										<ArticleManagerState ref={spanRef}>
											{' '}
											{isEmpty(stateArticle)
												? translations['ref__status__item_unactive']
												: translations[stateArticle.translationKey]}
										</ArticleManagerState>
									</StateWrapper>
								) : (
									<ArticleManagerState ref={spanRef} width={true}>
										{' '}
										{isEmpty(stateArticle)
											? translations['ref__status__item_unactive']
											: translations[stateArticle.translationKey]}
									</ArticleManagerState>
								)}
							</ArticleManagerSubPart>
							<ArticleManagerSubPart>
								<LabelText>{translations['page__itemsRef__itemSheet_form_itemCode']}* :</LabelText>
								<InputWrapper>
									<InputLogin
										name="itemCode"
										type="text"
										placeholder={translations['page__itemsRef__itemSheet_form_itemCode_prefilled']}
										ref={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
											maxLength: {
												value: 50,
												message: `50 ${translations['common__text__charMax']}`,
											},
											minLength: {
												value: 1,
												message: `1${translations['common__text__charMin']}`,
											},
										})}
									/>
									{errors.itemCode && <ErrorInputMsg>{errors.itemCode.message}</ErrorInputMsg>}
								</InputWrapper>
							</ArticleManagerSubPart>
							<ArticleManagerSubPart>
								<LabelText>{translations['page__itemsRef__itemSheet_form_nameRef']}* :</LabelText>
								<InputWrapper>
									<InputLogin
										name="refName"
										type="text"
										placeholder={translations['page__itemsRef__itemSheet_form_nameRef_prefilled']}
										ref={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
											maxLength: {
												value: 150,
												message: `150 ${translations['common__text__charMax']}`,
											},
											minLength: {
												value: 5,
												message: `5 ${translations['common__text__charMin']}`,
											},
										})}
									/>
									{errors.refName && <ErrorInputMsg>{errors.refName.message}</ErrorInputMsg>}
								</InputWrapper>
							</ArticleManagerSubPart>
							<ArticleManagerSubPart>
								<LabelText>{translations['page__itemsRef__itemSheet_form_shortDescription']} :</LabelText>
								<InputWrapper>
									<InputLogin
										name="shortDescription"
										type="text"
										placeholder={translations['page__itemsRef__itemSheet_form_shortDescription_prefilled']}
										ref={register({
											maxLength: {
												value: 80,
												message: `80 ${translations['common__text__charMax']}`,
											},
										})}
									/>
									{errors.shortDescription && <ErrorInputMsg>{errors.shortDescription.message}</ErrorInputMsg>}
								</InputWrapper>
							</ArticleManagerSubPart>
							<ArticleManagerSubPart>
								<LabelText>{translations['page__itemsRef__itemSheet_form_familly']}* :</LabelText>
								<div>
									<SelectInputWrapper>
										<SelectInputCustom
											width="208"
											name="idFamilly"
											ref={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
												validate: (value) => value > 0 || translations['common__text__requiredField'],
											})}
											defaultValues="0"
											className={watch('idFamilly') > 0 ? 'active' : ''}
											onChange={(e) => handleFamilyChoice(parseInt(e.target.value))}
											disabled={isUpdate}
										>
											<OptionCustom value="0" hidden>
												{translations['page__itemsRef__itemSheet_form_familly_prefilled']}
											</OptionCustom>
											{map(articleManager.availableOptions.itemFamiliesTypesAccsAvailable, (elem, id) => {
												return (
													<OptionCustom key={id} value={elem.id} target={true}>
														{translations[elem.translationKey]}
													</OptionCustom>
												)
											})}
										</SelectInputCustom>
									</SelectInputWrapper>
									{errors.idFamilly && <ErrorInputMsg>{errors.idFamilly.message}</ErrorInputMsg>}
								</div>
							</ArticleManagerSubPart>
							{typeList.length > 0 && (
								<ArticleManagerSubPart>
									<LabelText>{translations['page__itemsRef__itemSheet_form_type']}* :</LabelText>
									<div>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="idItemType"
												ref={register({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
													validate: (value) => value > 0 || translations['common__text__requiredField'],
												})}
												onChange={(e) => handleTypeChosen(e.target.value)}
												disabled={isUpdate}
												className={watch('idItemType') > 0 ? 'active' : ''}
												defaultValues=""
											>
												<OptionCustom value="0" hidden>
													{translations['page__itemsRef__itemSheet_form_type_prefilled']}
												</OptionCustom>
												{map(typeList, (elem, id) => {
													return (
														<OptionCustom key={id} value={elem.id} target={true}>
															{translations[elem.translationKey]}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.idItemType && <ErrorInputMsg>{errors.idItemType.message}</ErrorInputMsg>}
									</div>
								</ArticleManagerSubPart>
							)}
							{(isTypeChosen || isUpdate) && (
								<Fragment>
									<ArticleManagerSubPart>
										<LabelText>{translations['page__itemsRef__itemSheet_form_brand']}* :</LabelText>
										<div>
											<SelectInputWrapper>
												<SelectInputCustom
													width="208"
													name="idBrand"
													defaultValues=""
													className={watch('idBrand') > 0 ? 'active' : ''}
													ref={register({
														required: {
															value: true,
															message: translations['common__text__requiredField'],
														},
														validate: (value) => value > 0 || translations['common__text__requiredField'],
													})}
												>
													<OptionCustom value="0" hidden>
														{translations['page__itemsRef__itemSheet_form_brand_prefilled']}
													</OptionCustom>
													{map(articleManager.availableOptions.brandsAvailable, (elem, id) => {
														return (
															<OptionCustom key={id} value={elem.id} target={true}>
																{elem.label}
															</OptionCustom>
														)
													})}
												</SelectInputCustom>
											</SelectInputWrapper>
											{errors.idBrand && <ErrorInputMsg>{errors.idBrand.message}</ErrorInputMsg>}
										</div>
									</ArticleManagerSubPart>
									<ArticleManagerSubPart>
										<LabelText>{translations['page__itemsRef__itemSheet_form_itemSpecificity']}* :</LabelText>
										<div>
											<SelectInputWrapper>
												<SelectInputCustom
													width="208"
													name="idItemSpec"
													className={watch('idItemSpec') > 0 ? 'active' : ''}
													ref={register({
														required: {
															value: true,
															message: translations['common__text__requiredField'],
														},
														validate: (value) => value > 0 || translations['common__text__requiredField'],
													})}
												>
													<OptionCustom value="0" hidden>
														{translations['page__itemsRef__itemSheet_form_itemSpecificity_prefilled']}
													</OptionCustom>
													{map(articleManager.availableOptions.specificitiesAvailable, (elem, id) => {
														return (
															<OptionCustom key={id} value={elem.id} target={true}>
																{translations[elem.translationKey]}
															</OptionCustom>
														)
													})}
												</SelectInputCustom>
											</SelectInputWrapper>
											{errors.idItemSpec && <ErrorInputMsg>{errors.idItemSpec.message}</ErrorInputMsg>}
										</div>
									</ArticleManagerSubPart>
									<ArticleManagerSubPart>
										<LabelText>{translations['page__itemsRef__itemSheet_form_withDeposit']}* :</LabelText>
										<Controller
											control={control}
											name="withDeposit"
											as={ToggleFilters}
											checked={withDeposit}
											onChangeHandler={() => {
												if (!isUpdate && idItemType > 1) {
													setWithDeposit((prevState) => !prevState)
													setValue('withDeposit', !withDeposit)
												}
											}}
											rules={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
											})}
											labelPrev={translations['common__text__yes']}
											labelNext={translations['common__text__no']}
											size="large"
											reverseCheck
											disabled={isUpdate}
										/>
									</ArticleManagerSubPart>
									<ArticleManagerSubPart>
										<LabelText>{translations['page__itemsRef__itemSheet_form_itemPicture']} :</LabelText>
										<ControllerFileWrapper>
											<input
												type="file"
												id="pictureBase64"
												name="pictureBase64"
												multiple="false"
												onChange={(e) => handleFileReading(e.target.files[0])}
												accept=".gif,.img,.png,.jpg, .jpeg"
											/>
											<LabelFileCustom for="pictureBase64" width="208">
												{
													/*previewImageName.length > 0
                                                    ?
                                                    previewImageName
                                                    :*/
													translations['page__itemsRef__itemSheet_form_itemPicture_prefilled']
												}
											</LabelFileCustom>
											<span>{translations['page__itemsRef__itemSheet_form_itemPicture_propertie']}</span>
										</ControllerFileWrapper>
									</ArticleManagerSubPart>
									<ArticleManagerSubPart class="va-top">
										{errors.pictureBase64 && <ErrorInputMsg>{errors.pictureBase64.message}</ErrorInputMsg>}
										<PreviewFileWrapper>
											<img src={previewBase64} />
										</PreviewFileWrapper>
										{previewBase64.length > 0 && (
											<Tooltip
												tooltipId={'deletedChooice'}
												translationsKey={'tooltip__admin__global__deletedChooice'}
												position="left"
											>
												<SearchResetCustom
													onClick={() => {
														handleDeletePicture()
													}}
												/>
											</Tooltip>
										)}
									</ArticleManagerSubPart>
								</Fragment>
							)}
						</ArticleManagerPart>
						<ArticleManagerPart>
							<ArticleManagerSubPartTextarea>
								<LabelText>{translations['page__itemsRef__itemSheet_form_description']} :</LabelText>
								<InputWrapper>
									<TextareaStyled
										name="description"
										placeholder={translations['page__itemsRef__itemSheet_form_description_prefilled']}
										ref={register({})}
									/>
								</InputWrapper>
							</ArticleManagerSubPartTextarea>
							<ArticleManagerSubPart>
								<LabelText>{translations['page__itemsRef__itemSheet_form_netWeight']} :</LabelText>
								<InputWrapper>
									<InputLogin
										name="netWeight"
										type="text"
										placeholder={translations['page__itemsRef__itemSheet_form_netWeight_prefilled']}
										ref={register({
											maxLength: {
												value: 50,
												message: `50 ${translations['common__text__charMax']}`,
											},
											pattern: {
												value: RegExp(/^[0-9 . ,]*$/),
												message: translations['common__text__invalidValue'],
											},
											validate: (value) => value.length === 0 || !isNaN(parseFloat(value.replace(',', '.'))),
										})}
									/>
									{errors.netWeight && <ErrorInputMsg>{errors.netWeight.message}</ErrorInputMsg>}
								</InputWrapper>
							</ArticleManagerSubPart>
							<ArticleManagerSubPart>
								<LabelText>{translations['page__itemsRef__itemSheet_form_grossWeight']} :</LabelText>
								<InputWrapper>
									<InputLogin
										name="grossWeight"
										type="text"
										placeholder={translations['page__itemsRef__itemSheet_form_grossWeight_prefilled']}
										ref={register({
											maxLength: {
												value: 50,
												message: `50 ${translations['common__text__charMax']}`,
											},
											pattern: {
												value: RegExp(/^[0-9 . ,]*$/),
												message: translations['common__text__invalidValue'],
											},
											validate: (value) => value.length === 0 || !isNaN(parseFloat(value.replace(',', '.'))),
										})}
									/>
									{errors.grossWeight && <ErrorInputMsg>{errors.grossWeight.message}</ErrorInputMsg>}
								</InputWrapper>
							</ArticleManagerSubPart>
							<ArticleManagerSubPart>
								<LabelText>{translations['page__itemsRef__itemSheet_form_volume']} :</LabelText>
								<InputWrapper>
									<InputLogin
										name="volume"
										type="text"
										placeholder={translations['page__itemsRef__itemSheet_form_volume_prefilled']}
										ref={register({
											maxLength: {
												value: 50,
												message: `50 ${translations['common__text__charMax']}`,
											},
											pattern: {
												value: RegExp(/^[0-9 . ,]*$/),
												message: translations['common__text__invalidValue'],
											},
											validate: (value) => value.length === 0 || !isNaN(parseFloat(value.replace(',', '.'))),
										})}
									/>
									{errors.volume && <ErrorInputMsg>{errors.volume.message}</ErrorInputMsg>}
								</InputWrapper>
							</ArticleManagerSubPart>
							<ArticleManagerSubPart>
								<LabelText>{translations['page__itemsRef__itemSheet_form_height']} :</LabelText>
								<InputWrapper>
									<InputLogin
										name="heightInCm"
										type="text"
										placeholder={translations['page__itemsRef__itemSheet_form_height_prefilled']}
										ref={register({
											maxLength: {
												value: 50,
												message: `50 ${translations['common__text__charMax']}`,
											},
											pattern: {
												value: RegExp(/^[0-9 . ,]*$/),
												message: translations['common__text__invalidValue'],
											},
											validate: (value) => value.length === 0 || !isNaN(parseFloat(value.replace(',', '.'))),
										})}
									/>
									{errors.heightInCm && <ErrorInputMsg>{errors.heightInCm.message}</ErrorInputMsg>}
								</InputWrapper>
							</ArticleManagerSubPart>
							<ArticleManagerSubPartColumn>
								<LabelText>{translations['page__itemsRef__itemSheet_form_usages']} :</LabelText>
								<ArticleManagerSubPartUsagesHandler>
									{map(usagesList, (elem, id) => {
										const pic = find(usagePicsConfig, { id: elem.id })
										return (
											<ArticleManagerSubPartUsages>
												<input type="checkbox" checked={elem.active} onClick={() => handleUsagesList(id, elem.active)} />
												<img src={`${!isUndefined(pic) && pic.picture}`} />
												<LabelText>{elem.label}</LabelText>
											</ArticleManagerSubPartUsages>
										)
									})}
								</ArticleManagerSubPartUsagesHandler>
							</ArticleManagerSubPartColumn>
						</ArticleManagerPart>
						<ArticleManagerPart>{featuresRender}</ArticleManagerPart>
						{parseInt(idItemType) > 1 && !isUndefined(idItemType) && (
							<ArticleManagerPart>
								<ArticleManagerSubPart>
									<LabelText>{translations['page__itemsRef__itemSheet_form_accessories']} :</LabelText>
									<DropdownCheckbox
										title={translations['page__itemsRef__itemSheet_form_accessories_prefilled']}
										data={accessoriesList || []}
										paperTopPosition={'40'}
										selectActionsHandler={handleAccessoriesList}
										submitOnClose={() => null}
										target={'accessories'}
									/>
								</ArticleManagerSubPart>
								<ArticleManagerSubPartColumn>
									<div>
										{map(accessoriesList, (elem, id) => {
											return elem.active ? (
												<ArticleManagerSubPartAccesory>
													<img src={elem.picture === null ? noImage : `/${elem.picture}`} />
													<LabelText>{elem.label}</LabelText>
													<Tooltip
														tooltipId={`companyDetail_actionResetAccessory_${elem.id}`}
														translationsKey={'tooltip__admin__global__deletedChooice'}
														position="left"
													>
														<SearchResetCustom
															onClick={() => {
																handleAccessoriesList(elem.id, true)
															}}
														/>
													</Tooltip>
												</ArticleManagerSubPartAccesory>
											) : null
										})}
									</div>
								</ArticleManagerSubPartColumn>
							</ArticleManagerPart>
						)}
					</PageWrapperGrids>
				</form>
			</ArticleManagerWrapper>
		</Fragment>
	)
}

ArticleManager.propTypes = {}

ArticleManager.defaultPropTypes = {}

export default ArticleManager
